<div [class.hidden]="true">
    <img #el [src]="srcDestinatario" *ngIf="srcDestinatario">
</div>